import { useState } from "react";

interface ProgressProps {
  progress: number;
  onProgress: (e: ProgressEvent) => void;
}

const useProgress = (): ProgressProps => {
  const [progress, setProgress] = useState(0);

  const onProgress = (e: ProgressEvent): void => {
    const progress: number = (e.loaded * 100) / e.total;
    setProgress(progress);
  };

  return { progress, onProgress };
};

export default useProgress;
